import { createStore } from 'zustand';

import type { StoreApi } from 'zustand';

export type AlignmentStoreState = {
    readonly alignedCount: number;
    readonly alignmentScore: number;
    readonly hireCount: number;
    readonly notAlignedCount: number;
    readonly teamSizeCount: number;
    readonly uncertainCount: number;
};

export type AlignmentStoreActions = {};

export type AlignmentStore = AlignmentStoreActions & AlignmentStoreState;

export const createAlignmentStore = (): StoreApi<AlignmentStore> => {
    const store = createStore<AlignmentStore>(() => ({
        alignedCount: 5,
        alignmentScore: 81,
        hireCount: 4,
        notAlignedCount: 5,
        teamSizeCount: 31,
        uncertainCount: 2,
    }));

    return store;
};
